var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 54.9287C41.9117 54.9287 54 42.8404 54 27.9287C54 13.017 41.9117 0.928711 27 0.928711C12.0883 0.928711 0 13.017 0 27.9287C0 42.8404 12.0883 54.9287 27 54.9287Z",
    fill: "#FED402"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9996 50.5823C39.511 50.5823 49.6535 40.4398 49.6535 27.9283C49.6535 15.4169 39.511 5.27441 26.9996 5.27441C14.4882 5.27441 4.3457 15.4169 4.3457 27.9283C4.3457 40.4398 14.4882 50.5823 26.9996 50.5823Z",
    fill: "#FAC600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9994 5.27441C26.1827 5.27461 25.3666 5.31886 24.5547 5.40697C35.9001 6.63256 44.7639 16.2624 44.7639 27.9283C44.7639 39.5943 35.9001 49.2241 24.5547 50.4497C25.3666 50.5378 26.1827 50.5821 26.9994 50.5823C39.4943 50.5823 49.6533 40.4233 49.6533 27.9283C49.6533 15.4334 39.4943 5.27441 26.9994 5.27441Z",
    fill: "#E8B800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7832 21.2695H37.7369V36.6943H30.9096",
    stroke: "white",
    strokeWidth: 5.57982
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3301 21.2695H18.3764V36.6943H25.2037",
    stroke: "white",
    strokeWidth: 5.57982
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.f0e024cbc76bd9e957f33f44f2bc384a.svg";
export { ForwardRef as ReactComponent };